import styled from 'styled-components';

import { ReactComponent as CloseIcon } from '../../../../assets/images/popup-close-icon.svg';
import { newTheme } from '../../../../mainStyles';

export const StyledCloseIcon = styled(CloseIcon)`
  path {
    stroke: white;
  }
`;

export const StyledCloseButton = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 5;

  @media (max-width: 1207px) {
    top: 15px;
    right: 15px;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
`;

export const StyledTitleText = styled.div`
  font-family: ${newTheme.fontFamily.primary.medium};
  font-size: 33px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.02em;
  text-align: center;

  margin-bottom: 16px;
`;

export const StyledAddonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTextSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 60px 5px 32px;

  @media (max-width: 1080px) {
    padding: 5px 20px;
  }
`;
export const StyledAddonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledImageSection = styled.div`
  width: 65%;
  @media (max-width: 1080px) {
    width: 100%;
  }
  @media (max-width: 815px) {
    display: none;
  }

  ${({ bgImage }) =>
    bgImage && `background: url(${bgImage}) center center/cover no-repeat;`};
`;

export const StyledDescriptionText = styled.div`
  font-family: ${newTheme.fontFamily.primary.regular};
  font-size: 24px;
  font-weight: 500;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: center;

  color: #5d5d5b;

  margin-bottom: 16px;
`;

export const StyledSubTitleText = styled.div`
  font-family: ${newTheme.fontFamily.primary.medium};
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.02em;
  text-align: center;

  margin-bottom: 16px;
`;

export const StyledColumnTitleText = styled.div`
  font-family: ${newTheme.fontFamily.primary.medium};
  font-size: 19px;
  font-weight: 600;
  line-height: 23px;
  letter-spacing: -0.02em;
  text-align: center;
`;

export const StyledColumnDescriptionText = styled.div`
  font-family: ${newTheme.fontFamily.primary.regular};
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;

  color: #5d5d5b;
`;

export const StyledColumnsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  margin-bottom: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledColumn = styled.div`
  width: 49%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #ffffff;
  margin-bottom: 8px;

  border: 2px solid #131312;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 20px 0 10px;
`;

export const StyledAddButton = styled.button`
  font-family: ${newTheme.fontFamily.primary.medium};
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  padding: 16px 36px;
  border: 0;
  border-radius: 4px;
  margin-right: 16px;
  z-index: 10;
  cursor: pointer;

  color: white;
  background: #131312;

  &:hover {
    background: #212121;
  }
`;

export const StyledCancelButton = styled.button`
  font-family: ${newTheme.fontFamily.primary.medium};
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  padding: 16px 36px;
  border: 0;
  border-radius: 4px;
  margin-right: 16px;
  z-index: 10;
  cursor: pointer;

  color: #131312;
  background: white;
`;

export const StyledVideoWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
